/**
 * Rarity Configuration
 * Maps challenge difficulty to NFT rarity with consistent colors
 */

// Difficulty to Rarity mapping
export const DIFFICULTY_TO_RARITY = {
  'Easy': 'common',
  'Moderate': 'rare',
  'Hard': 'epic',
  'Expert': 'legendary'
};

// Rarity to Difficulty mapping (reverse)
export const RARITY_TO_DIFFICULTY = {
  'common': 'Easy',
  'rare': 'Moderate',
  'epic': 'Hard',
  'legendary': 'Expert'
};

// Rarity definitions with colors
export const RARITIES = {
  common: {
    id: 'common',
    name: 'Common',
    difficulty: 'Easy',
    color: '#6B7280',        // gray-500
    bgColor: '#F3F4F6',      // gray-100
    borderColor: '#D1D5DB',  // gray-300
    textColor: '#374151',    // gray-700
    gradient: 'from-gray-400 to-gray-600',
    tailwind: {
      bg: 'bg-gray-100',
      text: 'text-gray-700',
      border: 'border-gray-300',
      badge: 'bg-gray-500 text-white'
    }
  },
  rare: {
    id: 'rare',
    name: 'Rare',
    difficulty: 'Moderate',
    color: '#3B82F6',        // blue-500
    bgColor: '#DBEAFE',      // blue-100
    borderColor: '#93C5FD',  // blue-300
    textColor: '#1D4ED8',    // blue-700
    gradient: 'from-blue-400 to-blue-600',
    tailwind: {
      bg: 'bg-blue-100',
      text: 'text-blue-700',
      border: 'border-blue-300',
      badge: 'bg-blue-500 text-white'
    }
  },
  epic: {
    id: 'epic',
    name: 'Epic',
    difficulty: 'Hard',
    color: '#C53B8A',        // secondary-500 (magenta)
    bgColor: '#fce9f4',      // secondary-50
    borderColor: '#f297ca',  // secondary-200
    textColor: '#772353',    // secondary-700
    gradient: 'from-secondary-400 to-secondary-600',
    tailwind: {
      bg: 'bg-secondary-50',
      text: 'text-secondary-700',
      border: 'border-secondary-200',
      badge: 'bg-secondary-500 text-white'
    }
  },
  legendary: {
    id: 'legendary',
    name: 'Legendary',
    difficulty: 'Expert',
    color: '#F59E0B',        // amber-500
    bgColor: '#FEF3C7',      // amber-100
    borderColor: '#FCD34D',  // amber-300
    textColor: '#B45309',    // amber-700
    gradient: 'from-yellow-400 to-amber-500',
    tailwind: {
      bg: 'bg-amber-100',
      text: 'text-amber-700',
      border: 'border-amber-300',
      badge: 'bg-amber-500 text-white'
    }
  }
};

// Get rarity from difficulty
export const getRarityFromDifficulty = (difficulty) => {
  const rarityKey = DIFFICULTY_TO_RARITY[difficulty];
  return rarityKey ? RARITIES[rarityKey] : RARITIES.common;
};

// Get rarity config by key
export const getRarity = (rarityKey) => {
  return RARITIES[rarityKey] || RARITIES.common;
};

// All rarities as array (for iteration)
export const RARITY_LIST = [
  RARITIES.common,
  RARITIES.rare,
  RARITIES.epic,
  RARITIES.legendary
];

// Difficulty list
export const DIFFICULTY_LIST = ['Easy', 'Moderate', 'Hard', 'Expert'];

export default RARITIES;
